import React from "react"
import * as AppConstants from "../../../utility/AppConstants"
import InfoRiservatezza from "../../avvisi/InfoRiservatezza"

import TabRicaviCompensi from "./include/TabRicaviCompensi"
import TabValoreAggiunto from "./include/TabValoreAggiunto"
import TabReddito from "./include/TabReddito"
import TabIndicatori from "./include/TabIndicatori"
import TabGestioneCaratteristica from "./include/TabGestioneCaratteristica"
import TabRedditivita from "./include/TabRedditivita"
import TabGestioneExtra from "./include/TabGestioneExtra"
import TabIndicatoriSpecifici from "./include/TabIndicatoriSpecifici"
import TabAnomalie from "./include/TabAnomalie"
import TabTitle from "./include/TabTitle"

import HeaderTableTotali from "../../table/HeaderTableTotali"
import BodyTable from "../../table/BodyTable"
import {
    Table,
    SimpleCard,
    Collapsible
} from "@sogei/react-web-components-catalog"

function TabTotali(props: any) {
    let totalePersoneFisiche = props.totalePersoneFisiche
    let totaleSocietaPersone = props.totaleSocietaPersone
    let totaleSocCapitaliEntiNonComm = props.totaleSocCapitaliEntiNonComm
    let totale = props.totale

    return (
        <div id="tab-totali">
            <TabTitle title={AppConstants.TITLE_TOTALI} {...props} />

            <div className="row">
                <div className="col-12">
                    <SimpleCard
                        cardType="default"
                        title={""}
                        body={
                            <div className="table-responsive">
                                <Table
                                    tableHead={
                                        <HeaderTableTotali
                                            codIsa={props.codIsa}
                                            macroarea={props.macroarea}
                                        />
                                    }
                                    tableBody={
                                        <>
                                            <BodyTable
                                                isCampo1={true}
                                                isCampo2={true}
                                                isCampo3={true}
                                                isCampo5={true}
                                                campo1={totalePersoneFisiche}
                                                campo2={totaleSocietaPersone}
                                                campo3={
                                                    totaleSocCapitaliEntiNonComm
                                                }
                                                campo5={totale}
                                            />
                                        </>
                                    }
                                    tableOptions={["table-striped"]}
                                >
                                    <caption className="sr-only">
                                        {AppConstants.TITLE_TOTALI}{" "}
                                    </caption>
                                </Table>
                            </div>
                        }
                    />
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <h1 className="h3"> {AppConstants.DATI_AFFIDABILITA} </h1>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <Collapsible
                        cardType="default"
                        title={AppConstants.DATI_RICAVI_COMPENSI}
                        titleHeading="h3"
                        body={
                        <>
                            <div className="table-responsive">
                                <Table
                                    tableHead={
                                        <HeaderTableTotali
                                            codIsa={props.codIsa}
                                            macroarea={props.macroarea}
                                        />
                                    }
                                    tableBody={
                                        <>
                                            <TabRicaviCompensi
                                                isCampo1={true}
                                                isCampo2={true}
                                                isCampo3={true}
                                                isCampo5={true}
                                                campo1={totalePersoneFisiche}
                                                campo2={totaleSocietaPersone}
                                                campo3={
                                                    totaleSocCapitaliEntiNonComm
                                                }
                                                campo5={totale}
                                            />
                                        </>
                                    }
                                    tableOptions={["table-striped"]}
                                >
                                    <caption className="sr-only">
                                        {AppConstants.TITLE_TOTALI} -{" "}
                                        {AppConstants.DATI_RICAVI_COMPENSI}
                                    </caption>
                                </Table>
                            </div>
                            <div className="info_ricavi_compensi">
                                {AppConstants.INFO_RICAVI_COMPENSI}
                            </div>
                            </>
                        }
                        id="ricavi-compensi-totali"
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <Collapsible
                        cardType="default"
                        title={AppConstants.DATI_VALORE_AGGIUNTO}
                        titleHeading="h3"
                        body={
                            <div className="table-responsive">
                                <Table
                                    tableHead={
                                        <HeaderTableTotali
                                            codIsa={props.codIsa}
                                            macroarea={props.macroarea}
                                        />
                                    }
                                    tableBody={
                                        <>
                                            <TabValoreAggiunto
                                                isCampo1={true}
                                                isCampo2={true}
                                                isCampo3={true}
                                                isCampo5={true}
                                                campo1={totalePersoneFisiche}
                                                campo2={totaleSocietaPersone}
                                                campo3={
                                                    totaleSocCapitaliEntiNonComm
                                                }
                                                campo5={totale}
                                            />
                                        </>
                                    }
                                    tableOptions={["table-striped"]}
                                >
                                    <caption className="sr-only">
                                        {AppConstants.TITLE_TOTALI} -{" "}
                                        {AppConstants.DATI_VALORE_AGGIUNTO}
                                    </caption>
                                </Table>
                            </div>
                        }
                        id="valore-aggiunto-totali"
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <Collapsible
                        cardType="default"
                        title={AppConstants.DATI_REDDITO}
                        titleHeading="h3"
                        body={
                            <>
                            <div className="table-responsive">
                                <Table
                                    tableHead={
                                        <HeaderTableTotali
                                            codIsa={props.codIsa}
                                            macroarea={props.macroarea}
                                        />
                                    }
                                    tableBody={
                                        <>
                                            <TabReddito
                                                isCampo1={true}
                                                isCampo2={true}
                                                isCampo3={true}
                                                isCampo5={true}
                                                campo1={totalePersoneFisiche}
                                                campo2={totaleSocietaPersone}
                                                campo3={
                                                    totaleSocCapitaliEntiNonComm
                                                }
                                                campo5={totale}
                                            />
                                        </>
                                    }
                                    tableOptions={["table-striped"]}
                                >
                                    <caption className="sr-only">
                                        {AppConstants.TITLE_TOTALI} -{" "}
                                        {AppConstants.DATI_REDDITO}
                                    </caption>
                                </Table>
                            </div>
                            <div className="info_ricavi_compensi">
                                {AppConstants.INFO_REDDITO}
                            </div>
                            </>
                        }
                        id="reddito-totali"
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <Collapsible
                        cardType="default"
                        title={AppConstants.DATI_INDICATORI_ELEM_AFF}
                        titleHeading="h3"
                        body={
                            <div className="table-responsive">
                                <Table
                                    tableHead={
                                        <HeaderTableTotali
                                            codIsa={props.codIsa}
                                            macroarea={props.macroarea}
                                        />
                                    }
                                    tableBody={
                                        <>
                                            <TabIndicatori
                                                isCampo1={true}
                                                isCampo2={true}
                                                isCampo3={true}
                                                isCampo5={true}
                                                campo1={totalePersoneFisiche}
                                                campo2={totaleSocietaPersone}
                                                campo3={
                                                    totaleSocCapitaliEntiNonComm
                                                }
                                                campo5={totale}
                                            />
                                        </>
                                    }
                                    tableOptions={["table-striped"]}
                                >
                                    <caption className="sr-only">
                                        {AppConstants.TITLE_TOTALI} -{" "}
                                        {AppConstants.DATI_INDICATORI_ELEM_AFF}
                                    </caption>
                                </Table>
                            </div>
                        }
                        id="indicatori-totali"
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-12">&nbsp;</div>
            </div>

            <div className="row">
                <div className="col-12">
                    <h1 className="h3"> {AppConstants.DATI_ANOMALIA} </h1>
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <Collapsible
                        cardType="default"
                        title={AppConstants.DATI_ANOMALIA_GESTIONE_CAR}
                        titleHeading="h3"
                        body={
                            <div className="table-responsive">
                                <Table
                                    tableHead={
                                        <HeaderTableTotali
                                            codIsa={props.codIsa}
                                            macroarea={props.macroarea}
                                        />
                                    }
                                    tableBody={
                                        <>
                                            <TabGestioneCaratteristica
                                                isCampo1={true}
                                                isCampo2={true}
                                                isCampo3={true}
                                                isCampo5={true}
                                                campo1={totalePersoneFisiche}
                                                campo2={totaleSocietaPersone}
                                                campo3={
                                                    totaleSocCapitaliEntiNonComm
                                                }
                                                campo5={totale}
                                            />
                                        </>
                                    }
                                    tableOptions={["table-striped"]}
                                >
                                    <caption className="sr-only">
                                        {AppConstants.TITLE_TOTALI} -{" "}
                                        {AppConstants.DATI_ANOMALIA} -{" "}
                                        {
                                            AppConstants.DATI_ANOMALIA_GESTIONE_CAR
                                        }
                                    </caption>
                                </Table>
                            </div>
                        }
                        id="gestione-caratteristica-totali"
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <Collapsible
                        cardType="default"
                        title={AppConstants.DATI_ANOMALIA_REDDITIVITA}
                        titleHeading="h3"
                        body={
                            <div className="table-responsive">
                                <Table
                                    tableHead={
                                        <HeaderTableTotali
                                            codIsa={props.codIsa}
                                            macroarea={props.macroarea}
                                        />
                                    }
                                    tableBody={
                                        <>
                                            <TabRedditivita
                                                isCampo1={true}
                                                isCampo2={true}
                                                isCampo3={true}
                                                isCampo5={true}
                                                campo1={totalePersoneFisiche}
                                                campo2={totaleSocietaPersone}
                                                campo3={
                                                    totaleSocCapitaliEntiNonComm
                                                }
                                                campo5={totale}
                                            />
                                        </>
                                    }
                                    tableOptions={["table-striped"]}
                                >
                                    <caption className="sr-only">
                                        {AppConstants.TITLE_TOTALI} -{" "}
                                        {AppConstants.DATI_ANOMALIA}-{" "}
                                        {AppConstants.DATI_ANOMALIA_REDDITIVITA}
                                    </caption>
                                </Table>
                            </div>
                        }
                        id="gestione-redditivita-totali"
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <Collapsible
                        cardType="default"
                        title={AppConstants.DATI_ANOMALIA_GESTIONE_EXTRA}
                        titleHeading="h3"
                        body={
                            <div className="table-responsive">
                                <Table
                                    tableHead={
                                        <HeaderTableTotali
                                            codIsa={props.codIsa}
                                            macroarea={props.macroarea}
                                        />
                                    }
                                    tableBody={
                                        <>
                                            <TabGestioneExtra
                                                isCampo1={true}
                                                isCampo2={true}
                                                isCampo3={true}
                                                isCampo5={true}
                                                campo1={totalePersoneFisiche}
                                                campo2={totaleSocietaPersone}
                                                campo3={
                                                    totaleSocCapitaliEntiNonComm
                                                }
                                                campo5={totale}
                                            />
                                        </>
                                    }
                                    tableOptions={["table-striped"]}
                                >
                                    <caption className="sr-only">
                                        {AppConstants.TITLE_TOTALI} -{" "}
                                        {AppConstants.DATI_ANOMALIA}-{" "}
                                        {
                                            AppConstants.DATI_ANOMALIA_GESTIONE_EXTRA
                                        }
                                    </caption>
                                </Table>
                            </div>
                        }
                        id="gestione-extra-totali"
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <Collapsible
                        cardType="default"
                        title={AppConstants.DATI_ANOMALIA_INDICATORI_SPECIFICI}
                        titleHeading="h3"
                        body={
                            <div className="table-responsive">
                                <Table
                                    tableHead={
                                        <HeaderTableTotali
                                            codIsa={props.codIsa}
                                            macroarea={props.macroarea}
                                        />
                                    }
                                    tableBody={
                                        <>
                                            <TabIndicatoriSpecifici
                                                isCampo1={true}
                                                isCampo2={true}
                                                isCampo3={true}
                                                isCampo5={true}
                                                campo1={totalePersoneFisiche}
                                                campo2={totaleSocietaPersone}
                                                campo3={
                                                    totaleSocCapitaliEntiNonComm
                                                }
                                                campo5={totale}
                                            />
                                        </>
                                    }
                                    tableOptions={["table-striped"]}
                                >
                                    <caption className="sr-only">
                                        {AppConstants.TITLE_TOTALI} -{" "}
                                        {AppConstants.DATI_ANOMALIA} -{" "}
                                        {
                                            AppConstants.DATI_ANOMALIA_INDICATORI_SPECIFICI
                                        }
                                    </caption>
                                </Table>
                            </div>
                        }
                        id="indicatori-specifici-totali"
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <Collapsible
                        cardType="default"
                        title={AppConstants.DATI_ANOMALIA_ALTRI_INDICATORI}
                        titleHeading="h3"
                        body={
                            <div className="table-responsive">
                                <Table
                                    tableHead={
                                        <HeaderTableTotali
                                            codIsa={props.codIsa}
                                            macroarea={props.macroarea}
                                        />
                                    }
                                    tableBody={
                                        <>
                                            <TabAnomalie
                                                isCampo1={true}
                                                isCampo2={true}
                                                isCampo3={true}
                                                isCampo5={true}
                                                campo1={totalePersoneFisiche}
                                                campo2={totaleSocietaPersone}
                                                campo3={
                                                    totaleSocCapitaliEntiNonComm
                                                }
                                                campo5={totale}
                                            />
                                        </>
                                    }
                                    tableOptions={["table-striped"]}
                                >
                                    <caption className="sr-only">
                                        {AppConstants.TITLE_TOTALI} -{" "}
                                        {AppConstants.DATI_ANOMALIA} -{" "}
                                        {
                                            AppConstants.DATI_ANOMALIA_ALTRI_INDICATORI
                                        }
                                    </caption>
                                </Table>
                            </div>
                        }
                        id="altri-indicatori-totali"
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <InfoRiservatezza />
                </div>
            </div>
        </div>
    )
}

export default TabTotali
